import { IRootState } from '../../../root';
import { IUtmState } from './utm.state';

export class UtmSelectors {
  static readonly utmState = (state: IRootState): IUtmState => {
    return state.utm as IUtmState;
  };
}
